/**
 * 加密工具类
 * 使用 AES 加密算法，提供安全的本地存储加密
 * 
 * 注意：需要安装 crypto-js 依赖
 * npm install crypto-js
 */

// 导入 crypto-js
import CryptoJS from 'crypto-js'

/**
 * 生成加密密钥（基于设备指纹和固定盐值）
 * @param {string} deviceFingerprint 设备指纹
 * @returns {string} 加密密钥
 */
function generateEncryptionKey(deviceFingerprint) {
  // 使用固定盐值 + 设备指纹生成密钥
  const salt = 'ZX_SYSTEM_SALT_2025'
  const combined = salt + deviceFingerprint
  // 使用 SHA256 生成固定长度的密钥
  return CryptoJS.SHA256(combined).toString()
}

/**
 * AES 加密
 * @param {string} plaintext 明文
 * @param {string} deviceFingerprint 设备指纹
 * @returns {string} 加密后的Base64字符串
 */
export function encrypt(plaintext, deviceFingerprint) {
  if (!plaintext || !deviceFingerprint) {
    throw new Error('明文和设备指纹不能为空')
  }
  
  if (!CryptoJS) {
    throw new Error('crypto-js 未安装，无法使用加密功能。请运行: npm install crypto-js')
  }
  
  try {
    const key = generateEncryptionKey(deviceFingerprint)
    const encrypted = CryptoJS.AES.encrypt(plaintext, key).toString()
    return encrypted
  } catch (error) {
    console.error('加密失败:', error)
    throw new Error('加密失败: ' + error.message)
  }
}

/**
 * AES 解密
 * @param {string} ciphertext 密文（Base64字符串）
 * @param {string} deviceFingerprint 设备指纹
 * @returns {string} 解密后的明文
 */
export function decrypt(ciphertext, deviceFingerprint) {
  if (!ciphertext || !deviceFingerprint) {
    throw new Error('密文和设备指纹不能为空')
  }
  
  if (!CryptoJS) {
    throw new Error('crypto-js 未安装，无法使用解密功能。请运行: npm install crypto-js')
  }
  
  try {
    const key = generateEncryptionKey(deviceFingerprint)
    const decrypted = CryptoJS.AES.decrypt(ciphertext, key)
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8)
    
    if (!plaintext) {
      throw new Error('解密失败：可能是设备指纹不匹配或数据已损坏')
    }
    
    return plaintext
  } catch (error) {
    console.error('解密失败:', error)
    throw new Error('解密失败: ' + error.message)
  }
}

